export class Address {
    public addressNumberId: number;
    public id: number;
    public entityId: number;
    public addressTypeId: number;
    public jurisdictionId: number;
    public countyId: number;
    public countryId: number;
    public isMilitary: boolean;
    public inCareOf: string;
    public addressLine1: string;
    public addressLine2: string;
    public latitude: string;
    public longitude: string;
    public city: string;
    public postalZipCode: string;
    public postalDeliveryCode: string;
    public internationalJurisdiction: string;
    public isOveridden: boolean;
    public isUndeliverable: boolean;
    public undeliverableDate: any;
    public sosOptOut: boolean;

    public isPreferredContactMethod: boolean;
    public nonMilitaryJurisdictionId: number;
    public militaryJurisdictionId: number;
    public militaryCityPrefixTypeId = 0;
    public militaryZipCode = 0;
    public emissionAreaTypeId: number;
    public addressConfidenceRatingTypeId: number;
    public geocodeConfidenceRatingTypeId: number;
    public landCategoryTypeId: number;
    public addressSourceTypeId: number;
    public updatedBy: string;
    public updatedDate: any;

    // For use on client side
    public viewId: number;
    public addressType: string;
    public county: string;
    public country: string;
    public state: string;

    public customerNumberId: any;
    public vehicleId: any;
    public businessTransactionItemKeyId: any;
    public isReadOnly: boolean;

    // For use in IRP
    public isEstablishedPlaceOfBusiness: boolean | null;
}
